export default (type: string) => {
    switch (type) {
        default:
            return import('./api').then(provider => provider.default);
    }
};
